import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'app/components/shared.module';
import { WidgetWrapperModule } from 'app/views/presentations/widgets/widgetWrapper.module';
import { UnsupportedWidget, UnsupportedWidgetComponent } from './unsupported.widget';

@NgModule({
    imports: [
        SharedModule,
        TranslateModule,
        WidgetWrapperModule.wrapWidget(UnsupportedWidget)
    ],
    declarations: [
        UnsupportedWidgetComponent
    ],
    entryComponents: [
        UnsupportedWidgetComponent
    ]
})
export class UnsupportedWidgetModule { }



// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/unsupported/unsupported.module.ts